module.exports = __webpack_public_path__ + "img/goodSigh.2908fa20.svg";